import type { ICardFillAdminJob } from '@/entities/card-fill-admin.entity';
import CardFillJobRow from '@/pages/admin/card-fill/card-fill-job-row';

export default function CardFillJobsTable({
	title,
	jobs,
	emptyText,
	onCancel,
	onRetry,
}: {
	title: string;
	jobs: ICardFillAdminJob[];
	emptyText: string;
	onCancel?: (jobId: string) => void;
	onRetry?: (jobId: string) => void;
}) {
	return (
		<section className='space-y-2'>
			{title ? <h2 className='text-sm font-medium'>{title}</h2> : null}
			{jobs.length === 0 ? (
				<p className='text-sm text-muted-foreground rounded-xl border border-dashed p-4'>{emptyText}</p>
			) : (
				<div className='space-y-2'>
					{jobs.map(job => (
						<CardFillJobRow key={job.id} job={job} onCancel={onCancel} onRetry={onRetry} />
					))}
				</div>
			)}
		</section>
	);
}
